"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneOutgoingCall = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneOutgoingCall_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.055 11.278.72-.719c.5-.5 1.178-.781 1.886-.781h1.561c.982 0 1.778.796 1.778 1.777v1.779c0 1.44-1.226 2.657-2.666 2.666C5.964 16 0 10.035 0 2.666 0 1.93.302 1.262.782.782A2.66 2.66 0 0 1 2.667 0h1.778c.981 0 1.777.796 1.777 1.778V3.34c0 .707-.28 1.386-.78 1.886l-.72.719a.882.882 0 0 0-.184 1.002 9.793 9.793 0 0 0 4.516 4.515c.115.056.24.084.364.084a.907.907 0 0 0 .637-.268ZM15 13.334c0 .88-.773 1.659-1.67 1.666C6.515 14.998 1 9.482 1 2.666c0-.458.187-.874.49-1.176A1.66 1.66 0 0 1 2.667 1h1.778c.43 0 .777.348.777.778V3.34c0 .442-.175.866-.488 1.178l-.719.72c-.538.538-.741 1.397-.375 2.148a10.8 10.8 0 0 0 4.973 4.974c.26.127.535.186.805.186a1.921 1.921 0 0 0 1.345-.56l.719-.72a1.663 1.663 0 0 1 1.179-.488h1.561c.43 0 .778.348.778.777v1.779Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0a.5.5 0 0 0 0 1h3.793L9.146 6.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5h-5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneOutgoingCall_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneOutgoingCall;
exports["default"] = _default;